// Global constants

const CANVAS_WIDTH = 2000;
const CANVAS_HEIGHT = 2000;

const UpsellCanvas = {};

let DEBUG_MODE = false;
if (window.location.hostname === '127.0.0.1') {
	DEBUG_MODE = true;
}

String.prototype.hashCode = function() {
	var hash = 0,
		i, chr;
	if (this.length === 0) return hash;
	for (i = 0; i < this.length; i++) {
		chr = this.charCodeAt(i);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
}

const canvasLog = function (message, trace = false) {
	if (DEBUG_MODE) {
		console.log('%c '+message, 'background: purple; color: white');
		if (trace) {
			console.trace();
		}
	}
}

CanvasRenderingContext2D.prototype.drawRoundedRect = function (x, y, width, height, radius, color) {
	if (width < 2 * radius)
		radius = width / 2;

	if (height < 2 * radius)
		radius = height / 2;
	this.fillStyle = color;
	this.beginPath();
	this.moveTo(x + radius, y);
	this.arcTo(x + width, y, x + width, y + height, radius);
	this.arcTo(x + width, y + height, x, y + height, radius);
	this.arcTo(x, y + height, x, y, radius);
	this.arcTo(x, y, x + width, y, radius);
	this.closePath();
	this.fill();
}

class BaseArea {
	fontFamily;
	type;
	size;
	duoAngle = 30;
	duoStart = 50;
	duoSplit = 17; // percent
	duoSplitWidth = 2; // percent
	duoSplitColor = "#ffffff";

	constructor(x, y, width, height, radius, maxTextWidth, maxTextHeight, type=null) {
		this.x = x;
		this.y = y;
		this.width = width;
		this.height = height;
		this.radius = radius;
		this.maxTextWidth = maxTextWidth;
		this.maxTextHeight = maxTextHeight;
		this.maxTextHeightHalf = this.maxTextHeight / 2;
		
		if (this.type != 'bagtag' || (this.type=='photo' && this.size.includes('BagTag'))) {
			this.textX = x + (this.width - this.maxTextWidth)/2;
			this.textY = y + (this.height - this.maxTextHeight)/2;
		}

		this.iconWidth = 184;
		this.iconHeight = 164;
		this.iconX = this.x + this.width/2 - this.iconWidth/2;
		this.iconY = this.y + (this.height - this.iconHeight)/2;
		this.hasIcon = false;
		this.iconPosition = 'left';
		this.type = type;
		//this.textX = x + (width - this.maxTextWidth) / 2;
		//this.textY = y;
	}

	drawBGColor(ctx) {
		if (this.backgroundColor) {
			if (this.backgroundColorAlt) {
				//let gradient = ctx.createLinearGradient(this.x, this.y, this.x+this.width+this.duoAdjustmentX, this.y+this.height+this.duoAdjustmentY);

				let angle = + this.duoAngle / 180 * Math.PI;

				let halfWidth = this.width / 2;
				let halfHeight = this.height / 2;
				let length = Math.sqrt(halfWidth * halfWidth + halfHeight * halfHeight);
				let centerX = this.x + halfWidth;
				let centerY = this.y + halfHeight;
				let deltaX = length * Math.cos(angle);
				let deltaY = length * Math.sin(angle);

				let gradient = ctx.createLinearGradient(
					centerX - deltaX,
					centerY - deltaY,
					centerX + deltaX,
					centerY + deltaY
				);

				let splitAt = this.duoSplit/100;
				let splitUntil = (this.duoSplit+this.duoSplitWidth)/100;
				gradient.addColorStop(0, this.backgroundColor);
				gradient.addColorStop(splitAt, this.backgroundColor);
				gradient.addColorStop(splitAt, this.duoSplitColor);
				gradient.addColorStop(splitUntil, this.duoSplitColor);
				gradient.addColorStop(splitUntil, this.backgroundColorAlt);
				gradient.addColorStop(1, this.backgroundColorAlt);
				ctx.fillStyle = gradient;
			} else {
				ctx.fillStyle = this.backgroundColor || "#ffffff";
			}
			ctx.shadowColor = "rgba(0,0,0,.1)";
			ctx.shadowBlur = 10;
			ctx.shadowOffsetX = 4;
			ctx.shadowOffsetY = 4;
			ctx.drawRoundedRect(this.x, this.y, this.width, this.height, this.radius);
			ctx.fill();
		}
	}

	drawText(ctx, texts, label, rotate= 0) {
		let maxHeight,
			fontSize = 9999,
			fsTemp,
			maxTextWidth = this.maxTextWidth,
			maxTextHeight = this.maxTextHeight,
			textX = this.textX + maxTextWidth / 2,
			textY,
			adjustTextX= 0,
			adjustTextY= 0,
			lines=[];

		if (this.hasIcon) {
			switch (this.iconPosition) {
				case 'left':
					maxTextWidth = this.maxTextWidth - this.iconWidth;
					adjustTextX = this.iconWidth/2;
					this.iconX = this.x + (this.height - this.iconHeight)/2;
					break;
				case 'top':
					adjustTextY = this.iconHeight/2;
					this.iconY = this.y + 15; //added 15px on top of the icon
					break;
			}
		}

		for (let i=1; i<=4; i++) {
			if (!texts['Line_'+i]) {
				if (i===1) {
					lines.push(label.defaults.Line_1);
				} else {
					continue;
				}
			} else {
				lines.push(texts['Line_'+i]);
			}
			maxHeight = this.maxTextHeight / lines.length;
			let tempText = texts['Line_'+i];
			if (!tempText) {
				tempText = label.defaults.Line_1;
			}
			fsTemp = this.calculateOptimalFontSize(ctx, tempText, maxTextWidth, maxHeight);
			if (fsTemp < fontSize) {
				fontSize = fsTemp;
			}
			if (this.size == 'mini') {
				break;
			}
		}

		ctx.font = `${fontSize}px ${this.fontFamily}`;

		if (['shoepals', 'shoepals_icon'].indexOf(this.type) >= 0 && this.rotate) {
			const centerX = this.textX + this.width / 2;
			const centerY = this.textY + this.height / 2;
		}

		for (let i=0; i<lines.length; i++) {
			if (this.mirrored) {
				textY = this.textMY + maxHeight/2 - fontSize * 0.2 + fontSize * 0.1 + maxHeight*i;
				textX = this.textMX + maxTextWidth / 2;
			} else {
				if (['shoepals', 'shoepals_icon'].indexOf(this.type) >= 0) {
					textX = this.textX;
				} else if (this.size == 'circleBagTags') {
					textX = this.x + maxTextWidth/2 + (this.width - maxTextWidth)/2 + maxTextWidth*0.45;
				} else if (this.size == 'rectangleBagTags') {
					textX = this.x + maxTextWidth/2 + (this.width - maxTextWidth)/2 + 35;
				} else {
					textX = this.x + maxTextWidth/2 + (this.width - maxTextWidth)/2;
				}
				if (this.iconPosition == 'left' && this.hasIcon) {
					textX += adjustTextX;
				}
				textY = this.textY + this.maxTextHeight/lines.length/2 + this.maxTextHeight/lines.length*i;
				if (this.hasIcon && this.iconPosition == 'top') {
					textY += adjustTextY;
				}
			}
			ctx.textAlign = "center";
			ctx.textBaseline = this.baseline;
			ctx.fillStyle = this.textColor + 'D8';
			ctx.fillText(lines[i], textX, textY);
			if (DEBUG_MODE) {
				ctx.strokeStyle = "red"; // temporary border around the text
				ctx.lineWidth = 3; // temporary border around the text
				ctx.strokeRect(textX-maxTextWidth/2, textY-this.maxTextHeight/2, maxTextWidth, this.maxTextHeight); // temporary border around the text
			}
		}
		if (texts['Line_Back'] && label.has_back) {
			let fs = this.calculateOptimalFontSize(ctx, texts['Line_Back'], maxTextWidth, this.maxTextHeightBack);
			ctx.font = `${fs}px ${this.fontFamily}`;
			ctx.textAlign = "center";
			ctx.textBaseline = this.baseline;
			ctx.fillStyle = this.textColorBack + 'D8';
			ctx.fillText(texts['Line_Back'], textX, this.textBackY);
			if (DEBUG_MODE) {
				ctx.strokeStyle = "red"; // temporary border around the text
				ctx.lineWidth = 3; // temporary border around the text
				ctx.strokeRect(textX-maxTextWidth/2, this.textBackY-this.maxTextHeightBack/2, maxTextWidth, this.maxTextHeightBack); // temporary border around the text
			}
		}
	}

	drawLetter(ctx, letter, label) {
		if (label.type == 'orbit') {
			this.addBlur(ctx);
		}

		if (letter == '' && label.type == 'monogram') {
			letter = label.defaults.Letter;
		}

		let textX = this.x + (this.height - this.iconHeight)/2 + this.iconWidth/2;
		let textY = this.y + (this.height/2);
		if (this.iconPosition == 'top') {
			textY = this.y + (this.width - this.maxTextWidth);
		}

		if (label.type == 'orbit') {
			let fontSize = this.iconHeight/1.3;
			ctx.font = `${fontSize}px OL-ICONS`;
			ctx.textBaseline = "middle";
			if (letter === 'x') {
				return;
			}
			textX -= 30;
			textY -= 10;
		} else {
			let fontSize = this.iconHeight;
			ctx.font = `${fontSize}px ${this.fontFamilyMono}`;
			ctx.textBaseline = this.monogram_baseline;
		}

		ctx.textAlign = "center";
		ctx.fillStyle = this.textColor + 'D8';
		ctx.fillText(letter, textX, textY);

		if (label.type == 'orbit') {
			this.removeBlur(ctx);
		}

		if (DEBUG_MODE) {
			ctx.strokeStyle = "red"; // temporary border around the text
			ctx.lineWidth = 3; // temporary border around the text
			ctx.strokeRect(textX-this.iconWidth/2, textY-this.iconHeight/2, this.iconWidth, this.iconHeight); // temporary border around the text
		}
	}

	drawTextOrbit(ctx, texts, label) {
		let maxHeight, maxHeightL1, maxHeightL2,
			fontSize = 9999,
			fs1, fs2,
			maxTextWidth = this.maxTextWidth,
			textX, // = this.textX + maxTextWidth / 2,
			textY,
			adjustTextX = 0,
			adjustTextY = 0,
			lines=[];

		if (this.hasIcon) {
			switch (this.iconPosition) {
				case 'left':
					maxTextWidth = this.maxTextWidth - this.iconWidth;
					adjustTextX = this.iconWidth;
					this.iconX = this.x + (this.height - this.iconHeight)/2;
					break;
				case 'top':
					adjustTextY = this.iconHeight/2;
					this.iconY = this.y + 15; //added 15px on top of the icon
					break;
			}
		}

		for (let i=1; i<=2; i++) {
			if (!texts['Line_'+i]) {
				if (i===1) {
					lines.push(label.defaults.Line_1);
				} else {
					continue;
				}
			} else {
				lines.push(texts['Line_'+i]);
			}
		}

		this.addBlur(ctx);

		if (lines[1]) {
			maxHeightL1 = this.maxTextHeight * 0.9;
			maxHeightL2 = this.maxTextHeight * 0.4;
			fs1 = this.calculateOptimalFontSize(ctx, lines[0], maxTextWidth, maxHeightL1);
			fs2 = this.calculateOptimalFontSize(ctx, lines[1], maxTextWidth, maxHeightL2);
			if (fs2 > fs1*0.65) {
				fs2 = fs1*0.65;
			}
		} else {
			let adjustment = this.fontFamily === 'Arial' ? 0 : 22;
			maxHeightL1 = this.maxTextHeight;
			fs1 = this.calculateOptimalFontSize(ctx, lines[0], maxTextWidth, maxHeightL1);
		}

		textX = this.textX + maxTextWidth/2 + adjustTextX;
		textY = this.textY + maxHeightL1/2 + adjustTextY;

		ctx.font = `${fs1}px ${this.fontFamily}`;

		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		ctx.fillStyle = this.textColor + 'D8';
		ctx.fillText(lines[0], textX, textY);
		/*ctx.arc(textX, textY, 50, 0, 2 * Math.PI);
		ctx.lineWidth = 4;
		ctx.strokeStyle = "green";
		ctx.stroke();*/
		if (DEBUG_MODE) {
			ctx.strokeStyle = "blue"; // temporary border around the text
			ctx.lineWidth = 3; // temporary border around the text
			ctx.strokeRect(textX - maxTextWidth/2, textY - maxHeightL1/2, maxTextWidth, maxHeightL1); // temporary border around the text
		}

		if (lines[1]) {
			ctx.font = `${fs2}px ${this.fontFamily}`;
			textY = this.textY + maxHeightL1;
			ctx.textAlign = "center";
			ctx.textBaseline = "middle";
			ctx.fillStyle = this.textColor + 'D8';
			ctx.fillText(lines[1], textX, textY);
			if (DEBUG_MODE) {
				ctx.strokeStyle = "purple"; // temporary border around the text
				ctx.lineWidth = 3; // temporary border around the text
				ctx.strokeRect(textX - maxTextWidth/2, textY - maxHeightL2/2, maxTextWidth, maxHeightL2); // temporary border around the text
			}
		}

		this.removeBlur(ctx);
	}

	drawShoePalIcon(ctx) {
		let gap = this.gap;
		let border = this.iconHeight*0.02;
		//let img = this.shoepals_icon;

		// Get the temporary canvas and context
		let tempCanvas = document.createElement('canvas');
		let tempCtx = tempCanvas.getContext('2d');
		tempCanvas.width = this.shoepals_icon.width + border*2;
		tempCanvas.height = this.shoepals_icon.height + border*2;
		tempCtx.fillStyle = "transparent";
		tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
		tempCtx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);

		var dArr = [-1,-1, 0,-1, 1,-1, -1,0, 1,0, -1,1, 0,1, 1,1], // offset array
		//var dArr = [-1,-1, 0, -1, -1], // offset array
			s = border,  // thickness scale
			i = 0,  // iterator
			x = 10,  // final position
			y = 10;

		// draw images at offsets from the array scaled by s
		for(; i < dArr.length; i += 2)
			tempCtx.drawImage(this.shoepals_icon, 0, 0, this.shoepals_icon.width, this.shoepals_icon.height, x + dArr[i]*s, y + dArr[i+1]*s, this.shoepals_icon.width, this.shoepals_icon.height);

		// fill with color
		tempCtx.globalCompositeOperation = "source-in";
		tempCtx.fillStyle = this.backgroundColor || "rgba(255, 255, 255, 0)"; // Ensure the background is transparent
		tempCtx.fillRect(0,0, tempCanvas.width, tempCanvas.height);

		// draw original image in normal mode
		tempCtx.globalCompositeOperation = "source-over";
		tempCtx.drawImage(this.shoepals_icon, 0, 0, this.shoepals_icon.width, this.shoepals_icon.height, border, border, this.shoepals_icon.width, this.shoepals_icon.height);

		/*ctx.fillStyle = "red";
		ctx.fillRect(this.x, this.y, this.width, this.height);*/

		// Draw the rounded rectangles with shadows
		ctx.fillStyle = this.backgroundColor || "rgba(255, 255, 255, 0)"; // Ensure the background is transparent
		ctx.shadowColor = "rgba(0,0,0,.1)";
		ctx.shadowBlur = 6;
		ctx.shadowOffsetX = 4;
		ctx.shadowOffsetY = 4;

		ctx.drawRoundedRect(this.x, this.y, this.width / 2 - gap / 2, this.height, this.radius);
		ctx.fill();
		ctx.drawRoundedRect(this.x + this.width / 2 + gap/2, this.y, this.width / 2 - gap / 2, this.height, this.radius);
		ctx.fill();

		ctx.shadowBlur = 0;
		ctx.shadowOffsetX = 0;
		ctx.shadowOffsetY = 0;

		// preview the image before adding it to the canvas
		//document.getElementById('tempImage').src = tempCanvas.toDataURL();

		// draw left side of the icon
		ctx.drawImage(tempCanvas,
			0,
			0,
			this.shoepals_icon.width/2+border,
			this.shoepals_icon.height+border,
			this.x + this.width/2 - gap/2 - this.iconWidth/2-border,
			this.y - this.iconHeight*0.15, this.iconHeight/2+border,
			this.iconHeight+border
		);

		// draw right side of the icon
		ctx.drawImage(tempCanvas,
			this.shoepals_icon.width/2+border,
			0,
			this.shoepals_icon.width/2+border,
			this.shoepals_icon.height+border,
			this.x + this.width/2 + gap/2,
			this.y - this.iconHeight*0.15, this.iconHeight/2+border,
			this.iconHeight+border
		);
	}

	drawPhoto(ctx, photo) {
		let spacer = (this.width - this.iconWidth)/2;
		let radius = this.radius;
		let x = this.x + spacer;
		let y = this.y + spacer;
		let width = this.width - spacer*2;
		let height = this.width - spacer*2;

		ctx.save();

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.arcTo(x + width, y, x + width, y + height, radius);
		ctx.arcTo(x + width, y + height, x, y + height, radius);
		ctx.arcTo(x, y + height, x, y, radius);
		ctx.arcTo(x, y, x + width, y, radius);
		ctx.strokeStyle = 'black';
		ctx.lineWidth = 3;
		ctx.setLineDash([15]);
		ctx.stroke();
		ctx.closePath();
		ctx.clip();

		ctx.restore();

		if (photo.upload) {
			let img = new Image();
			img.src = photo.upload;
			img.onload = () => {
				let imgCrop = img.width;
				if (img.height < img.width ) {
					imgCrop = img.height;
				}
				imgCrop = imgCrop * (100-photo.z)/100;
				let sx = photo.x/100 * imgCrop;
				let sy = photo.y/100 * imgCrop;
				let sw = imgCrop
				let sh = imgCrop;
				let dx = this.x + spacer;
				let dy = this.y + spacer;
				let dw = this.iconWidth;
				let dh = this.iconWidth;

				photoCanvas.width = imgCrop;
				photoCanvas.height = imgCrop;
				photoCtx.drawImage(img, sx, sy, sw, sh, 0, 0, imgCrop, imgCrop);

				ctx.save();

				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				ctx.arcTo(x + width, y, x + width, y + height, radius);
				ctx.arcTo(x + width, y + height, x, y + height, radius);
				ctx.arcTo(x, y + height, x, y, radius);
				ctx.arcTo(x, y, x + width, y, radius);
				ctx.strokeStyle = 'black';
				ctx.lineWidth = 3;
				ctx.setLineDash([15]);
				ctx.stroke();
				ctx.closePath();

				ctx.clip();
				ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);

				ctx.restore();
			}
		}

		//ctx.restore();
	}
	
	drawPhoto2(ctx, photo) {
		let spacer = (this.height - this.iconHeight)/2;
		let radius = this.radius;
		let x = this.x + spacer;
		let y = this.y + spacer;
		let width = this.iconWidth;
		let height = this.iconHeight;
		
		ctx.save();
		
		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.arcTo(x + width, y, x + width, y + height, radius);
		ctx.arcTo(x + width, y + height, x, y + height, radius);
		ctx.arcTo(x, y + height, x, y, radius);
		ctx.arcTo(x, y, x + width, y, radius);
		ctx.strokeStyle = 'black';
		ctx.lineWidth = 3;
		ctx.setLineDash([15]);
		ctx.stroke();
		ctx.closePath();
		ctx.clip();
		
		ctx.restore();
		
		if (photo.upload) {
			let img = new Image();
			img.src = photo.upload;
			img.onload = () => {
				let imgCrop = img.width;
				if (img.height < img.width ) {
					imgCrop = img.height;
				}
				imgCrop = imgCrop * (100-photo.z)/100;
				let sx = photo.x/100 * imgCrop;
				let sy = photo.y/100 * imgCrop;
				let sw = imgCrop
				let sh = imgCrop;
				let dx = this.x + spacer;
				let dy = this.y + spacer;
				let dw = this.iconWidth;
				let dh = this.iconWidth;
				
				photoCanvas.width = imgCrop;
				photoCanvas.height = imgCrop;
				photoCtx.drawImage(img, sx, sy, sw, sh, 0, 0, imgCrop, imgCrop);
				
				ctx.save();
				
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				ctx.arcTo(x + width, y, x + width, y + height, radius);
				ctx.arcTo(x + width, y + height, x, y + height, radius);
				ctx.arcTo(x, y + height, x, y, radius);
				ctx.arcTo(x, y, x + width, y, radius);
				ctx.strokeStyle = 'black';
				ctx.lineWidth = 3;
				ctx.setLineDash([15]);
				ctx.stroke();
				ctx.closePath();
				
				ctx.clip();
				ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
				
				ctx.restore();
			}
		}
		
		//ctx.restore();
	}
	
	drawPhoto3(ctx, photo) {
		//let spacer = (this.height - this.iconHeight)/2;
		let spacer = 0;
		let radius = this.radius;
		let x = this.iconX;
		let y = this.iconY;
		let width = this.iconWidth;
		let height = this.iconHeight;
		
		ctx.save();
		
		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.arcTo(x + width, y, x + width, y + height, radius);
		ctx.arcTo(x + width, y + height, x, y + height, radius);
		ctx.arcTo(x, y + height, x, y, radius);
		ctx.arcTo(x, y, x + width, y, radius);
		ctx.strokeStyle = 'black';
		ctx.lineWidth = 3;
		ctx.setLineDash([15]);
		ctx.stroke();
		ctx.closePath();
		ctx.clip();
		
		ctx.restore();
		
		if (photo.upload) {
			let img = new Image();
			img.src = photo.upload;
			img.onload = () => {
				let imgCrop = img.width;
				if (img.height < img.width ) {
					imgCrop = img.height;
				}
				imgCrop = imgCrop * (100-photo.z)/100;
				let sx = photo.x/100 * imgCrop;
				let sy = photo.y/100 * imgCrop;
				let sw = imgCrop
				let sh = imgCrop;
				let dx = this.x + spacer;
				let dy = this.y + spacer;
				let dw = this.iconWidth * 2;
				let dh = this.iconHeight * 2;
				
				photoCanvas.width = imgCrop;
				photoCanvas.height = imgCrop;
				photoCtx.drawImage(img, sx, sy, sw, sh, 0, 0, imgCrop, imgCrop);
				
				ctx.save();
				
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				ctx.arcTo(x + width, y, x + width, y + height, radius);
				ctx.arcTo(x + width, y + height, x, y + height, radius);
				ctx.arcTo(x, y + height, x, y, radius);
				ctx.arcTo(x, y, x + width, y, radius);
				ctx.strokeStyle = 'black';
				ctx.lineWidth = 3;
				ctx.setLineDash([15]);
				ctx.stroke();
				ctx.closePath();
				
				ctx.clip();
				ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
				
				ctx.restore();
			}
		}
		
		//ctx.restore();
	}

	addBlur(ctx) {
		ctx.shadowBlur = 7;
		if (this.textColor === '#ffffff') {
			ctx.shadowColor = 'rgba(0, 0, 0, .8)';
		} else {
			ctx.shadowColor = 'rgba(255, 255, 255, .3)';
		}
		ctx.shadowOffsetX = 3;
		ctx.shadowOffsetY = 1;
	}

	removeBlur(ctx) {
		ctx.shadowBlur = 0;
		ctx.shadowColor = 'rgba(0, 0, 0, 0)';
	}

	calculateOptimalFontSize(ctx, text, maxWidth, maxHeight) {
		let fontSize = 1;
		let width,
			height;

		do {
			fontSize += 1;
			ctx.font = `${fontSize}px ${this.fontFamily}`;
			width = ctx.measureText(text).width;
			height = fontSize * 1.45; // 1.45 is an arbitrary value that works well for the font sizes we use
		} while (width < maxWidth && height < maxHeight);

		return fontSize - 1;
	}
}

class TagPalsArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 460,
			height= 405,
			maxTextWidth = 395,
			maxTextHeight = 180;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 70, maxTextWidth, maxTextHeight, type);
		this.iconPosition = 'top';
		this.size = 'tagPals';

		// duo tone split overwrites
		this.duoAngle = 105;
		this.duoSplit = 38; // percent
		this.duoSplitWidth = 6; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class PhotoLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 448,
			height= 564,
			maxTextWidth = 380,
			maxTextHeight = 120;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		let spacer = Math.round(width * 0.1);
		super(x, y, width, height, 50, maxTextWidth, maxTextHeight, type);
		this.hasIcon = true;
		this.iconPosition = 'top';
		this.iconWidth = width - spacer*2;
		this.iconHeight = width - spacer*2;
		this.size = 'photo';
	}
}

class CircleLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 450,
			height= 450,
			maxTextWidth = 315,
			maxTextHeight = 180;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 500, maxTextWidth, maxTextHeight, type);
		this.iconPosition = 'top';
		this.size = 'circle';

		// duo tone split overwrites
		this.duoAngle = 105;
		this.duoSplit = 35; // percent
		this.duoSplitWidth = 6; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class HexagonLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 448,
			height= 388,
			maxTextWidth = 360,
			maxTextHeight = 180;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 0, maxTextWidth, maxTextHeight, type);
		this.iconPosition = 'top';
		this.size = 'hexagon';
	}
}

class RectangleLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 840, 210, 35, 760, 140, type);
		this.size = 'large';

		// duo tone split overwrites
		this.duoAngle = -20;
		this.duoSplit = 19; // percent
		this.duoSplitWidth = 3; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class HolidayGiftTagsLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 500, 816, 35, 430, 130, type);
		this.size = 'holidaygifttags';
		this.textY += 310;
	}
}
class AllergyLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 840, 210, 35, 640, 140, type);
		this.iconWidth = this.height; //same as height to make it square
		this.iconHeight = this.height;
		this.iconX = this.x + this.width/2 - this.iconWidth/2;
		this.iconY = this.y + (this.height - this.iconHeight)/2;
		this.size = 'large';
	}
}

class ShoeLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 814,
			height= 415,
			maxTextWidth = 310,
			maxTextHeight = 120;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 15, maxTextWidth, maxTextHeight, type);
		this.textX = y + this.maxTextWidth/2 + (this.height - this.maxTextWidth)/2;
		this.textY = 2000 - x - this.maxTextHeight - this.maxTextWidth/5;
		this.textMX = 2000 - y - this.height + this.maxTextHeight/2;
		this.textMY = x + this.width - this.maxTextWidth/2;
		this.size = 'shoepals';
	}
}

class ShoeLabelArea2 extends BaseArea {
	constructor(x, y, width = 1350, height= 415, gap= 550, zoom=1, type) {
		let maxTextWidth = 310,
			maxTextHeight = 140,
			iconWidth = 495,
			iconHeight = 495;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 50, maxTextWidth, maxTextHeight, type);
		this.textX = y + this.maxTextWidth/2 + (this.height - this.maxTextWidth)/2;
		this.textY = 2000 - x - this.maxTextHeight - this.maxTextWidth/5;
		this.textMX = 2000 - y - this.height + this.maxTextHeight/2;
		this.textMY = x + this.width - this.maxTextWidth/2;
		this.iconWidth = iconWidth*zoom;
		this.iconHeight = iconHeight*zoom;
		this.gap = gap;
		this.size = 'shoepals_icon';
	}
}

class MediumRectangleLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 840,
			height= 280,
			maxTextWidth = 725,
			maxTextHeight = 182;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 35, maxTextWidth, maxTextHeight, type);
		this.size = 'medium';

		// duo tone split overwrites
		this.duoAngle = -12;
		this.duoSplit = 22; // percent
		this.duoSplitWidth = 3; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class MiniRectangleLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 960, 120, 15, 700, 90, type);
		this.iconPosition = 'left';
		this.iconWidth = 100;
		this.iconHeight = 89;
		this.iconY = this.iconY + 30; // Fix for the Y position for the icons of the mini labels
		this.size = 'mini';

		// duo tone split overwrites
		this.duoAngle = -18;
		this.duoSplit = 12; // percent
		this.duoSplitWidth = 2; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class OrbitLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 830, 310, 0, 730, 180, type);
		this.iconWidth = 150;
		this.iconHeight = 150;
		this.size = 'orbit';
	}
}

class RectangleBagTagArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 1224,
			height= 1723,
			maxTextWidth = 710,
			maxTextHeight = 350;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 0, maxTextWidth, maxTextHeight, type);
		this.textY = 380;
		this.textBackY = 1700;
		this.maxTextHeightBack = 150;
		this.size = 'rectangleBagTags';
		this.iconPosition = null;
	}
}

class CircleBagTagArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 1719,
			height= 1378,
			maxTextWidth = 780,
			maxTextHeight = 320;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 10, maxTextWidth, maxTextHeight, type);
		this.textY = y+height/2;
		this.size = 'circleBagTags';
		this.iconX = 425;
		this.iconY = 675;
		this.iconWidth = 450;
		this.iconHeight = 450;
		this.iconPosition = null;
	}
}

const labelAreas = {
	tagPals: [
		new TagPalsArea(112, 40),
		new TagPalsArea(112, 545),
		new TagPalsArea(112, 1049),
		new TagPalsArea(112, 1554),
		new TagPalsArea(1152, 751)
	],
	circle: [
		new CircleLabelArea(520, 1102),
		new CircleLabelArea(1294, 28),
		new CircleLabelArea(1294, 523),
		new CircleLabelArea(1294, 1031),
		new CircleLabelArea(1294, 1526),
	],
	hexagon: [
		new HexagonLabelArea(360, 1031),
		new HexagonLabelArea(1350, 200),
		new HexagonLabelArea(960, 523),
		new HexagonLabelArea(1350, 1031),
		new HexagonLabelArea(960, 1326),
	],
	large: [
		new RectangleLabelArea(590, 380),
		new RectangleLabelArea(140, 1225),
		new RectangleLabelArea(1037, 1225),
		new RectangleLabelArea(140, 1555),
		new RectangleLabelArea(1037, 1555),
	],
	holidaygifttags: [
		new HolidayGiftTagsLabelArea(220, 255),
		new HolidayGiftTagsLabelArea(1020, 255),
		new HolidayGiftTagsLabelArea(620, 1120),
		new HolidayGiftTagsLabelArea(1420, 1120),
	],
	allergy: [
		new AllergyLabelArea(590, 380),
		new AllergyLabelArea(140, 1225),
		new AllergyLabelArea(1037, 1225),
		new AllergyLabelArea(140, 1555),
		new AllergyLabelArea(1037, 1555),
	],
	medium: [
		new MediumRectangleLabelArea(104, 121),
		new MediumRectangleLabelArea(1081, 121),
		new MediumRectangleLabelArea(104, 588),
		new MediumRectangleLabelArea(1076, 588),
		new MediumRectangleLabelArea(175, 1175),
	],
	mini: [
		new MiniRectangleLabelArea(377, 165),
		new MiniRectangleLabelArea(1025, 528),
		new MiniRectangleLabelArea(266, 895),
		new MiniRectangleLabelArea(1000, 1285),
		new MiniRectangleLabelArea(50, 1681),
	],
	orbit: [
		new OrbitLabelArea(594, 1246),
		new OrbitLabelArea(597, 896),
	],
	rectangleBagTags: [
		new RectangleBagTagArea(382, 139)
	],
	circleBagTags: [
		new CircleBagTagArea(160, 406)
	],
	shoepals: [
		new ShoeLabelArea(139,142),
		new ShoeLabelArea(1101,138),
		new ShoeLabelArea(139,681),
		new ShoeLabelArea(1101,681),
		new ShoeLabelArea(139, 1214),
	],
	shoepals_icon: [
		//x,y,width,height,gap, zoom
		new ShoeLabelArea2(400,1050, 1650, 428, 600, .75),
	],
	M_C_CBT: [
		new CircleBagTagArea(285, 183, .69, 'bagtag'),
		new CircleLabelArea(280, 1155, 1, 'solid'),
		new MediumRectangleLabelArea(1184, 1329, .66, 'solid')
	],
	M_C_TP_CBT: [
		new CircleBagTagArea(117, 114, .69, 'bagtag'),
		new CircleLabelArea(1408, 184, 1, 'solid'),
		new MediumRectangleLabelArea(313, 1334, .66, 'solid'),
		new TagPalsArea(1418, 1213, .85, 'solid')

	],
	M_C_L_TP_CBT: [
		new CircleBagTagArea(763, 97, .7, 'bagtag'),
		new TagPalsArea(189, 129, .9, 'solid'),
		new CircleLabelArea(169, 758, 1, 'solid'),
		new MediumRectangleLabelArea(135, 1436, .7, 'solid'),
		new RectangleLabelArea(980, 1300, 1, 'solid')

	],
	M_C_TP_CBT_SP: [
		new CircleBagTagArea(62, 118, .69, 'bagtag'),
		new CircleLabelArea(1408, 47, .92, 'solid'),
		new MediumRectangleLabelArea(1328, 738, .66, 'solid'),
		new TagPalsArea(1444, 1266, .75, 'solid'),
		new ShoeLabelArea(150,1360, .75,'shoepals')
	],
	M_C_CBT_icon: [
		new CircleBagTagArea(285, 183, .69, 'bagtag'),
		new CircleLabelArea(280, 1155, 1, 'icon'),
		new MediumRectangleLabelArea(1184, 1329, .66, 'icon')
	],
	M_C_TP_CBT_icon: [
		new CircleBagTagArea(117, 114, .69, 'bagtag'),
		new CircleLabelArea(1408, 184, 1, 'icon'),
		new MediumRectangleLabelArea(313, 1334, .66, 'icon'),
		new TagPalsArea(1418, 1213, .85, 'icon')

	],
	M_C_CBT_graphics: [
		new CircleBagTagArea(285, 183, .69, 'bagtag'),
		new CircleLabelArea(280, 1155, 1, 'graphics'),
		new MediumRectangleLabelArea(1184, 1329, .66, 'graphics')
	],
	M_C_TP_CBT_graphics: [
		new CircleBagTagArea(117, 114, .69, 'bagtag'),
		new CircleLabelArea(1408, 184, 1, 'graphics'),
		new MediumRectangleLabelArea(313, 1334, .66, 'graphics'),
		new TagPalsArea(1418, 1213, .85, 'graphics')

	],
	M_C_TP_CBT_SP_icon: [
		new CircleBagTagArea(62, 118, .69, 'bagtag'),
		new CircleLabelArea(1408, 47, .92, 'icon'),
		new MediumRectangleLabelArea(1328, 738, .66, 'icon'),
		new TagPalsArea(1444, 1266, .75, 'icon'),
		new ShoeLabelArea2(60,1360, 900, 428, 40, .75, 'shoepals_icon')
	],
	M_C_TP_CBT_SP_graphics: [
		new CircleBagTagArea(62, 118, .69, 'bagtag'),
		new CircleLabelArea(1408, 47, .92, 'graphics'),
		new MediumRectangleLabelArea(1328, 738, .66, 'graphics'),
		new TagPalsArea(1444, 1266, .75, 'graphics'),
		new ShoeLabelArea2(60,1360, 900, 428, 40, .75, 'shoepals_icon')
	],
	photo: [
		new PhotoLabelArea(112, 40),
		new PhotoLabelArea(112, 670),
		new PhotoLabelArea(112, 1300),
		new PhotoLabelArea(1152, 954),
		new PhotoLabelArea(1152, 251)
	],
}

function hexToRgb(hex) {

	// Remove the "#" character if present
	hex = hex.replace("#", "");

	// Convert the hex value to RGB
	const bigint = parseInt(hex, 16);
	const r = (bigint >> 16) & 255;
	const g = (bigint >> 8) & 255;
	const b = bigint & 255;

	return { r, g, b };
}

window.addEventListener('scroll', function() {
	const customizer = document.querySelector('.customizer');
	const divBeforeNav = document.querySelector('#announcement-bar-announcement-bar');
	const stickyCanvas = document.querySelector('.sticky-canvas');
	const customizerApp = document.querySelector('.title');
	const canvasWrapper = document.querySelector('#inchbugCanvasWrapper');
	const placeholder = document.querySelector('.inchbugCanvasPlaceholder');

	// Exit early if required elements don't exist
	if (!divBeforeNav || !stickyCanvas || !customizer) return;

	const initialHeight = canvasWrapper ? canvasWrapper.offsetHeight : 0;

	// Check if divBeforeNav is visible within the viewport
	if (divBeforeNav.getBoundingClientRect().top >= 0) {
		stickyCanvas.classList.remove('position-sticky', 'sticky-top');
		customizer.classList.remove('stickyScrolling');
	} else {
		stickyCanvas.classList.add('position-sticky', 'sticky-top');
		customizer.classList.add('stickyScrolling');
	}

	if (customizerApp && canvasWrapper && placeholder) {
		if (customizerApp.getBoundingClientRect().top >= 0) {
			canvasWrapper.classList.remove('minipreview');
			placeholder.style.height = '0';
		} else {
			canvasWrapper.classList.add('minipreview');
			placeholder.style.height = `${initialHeight}px`;
		}
	}
});

document.addEventListener('DOMContentLoaded', function() {
	var sliderContainers = document.querySelectorAll('.customizer-option-slider');
	if (sliderContainers.length > 0) {
		sliderContainers.forEach(function(sliderContainer) {
			var slider = tns({
				container: sliderContainer,
				items: 2,
				nav: false,
				slideBy: 'page',
				controls: true,
				controlsPosition: 'top',
				controlsText:  ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
				edgePadding:0,
				gutter: 10,
				center:false,
				mouseDrag:true,
				loop:false,
				onInit: function () {
					sliderContainer.querySelectorAll('.tns-controls button').forEach(button => {
						button.type = 'button';
					});
				}
			});
		});
	}
	
	var olIconsSliderContainers = document.querySelectorAll('.customizer-ol-icons-slider');
	if (olIconsSliderContainers.length > 0) {
		olIconsSliderContainers.forEach(function(olIconsSliderContainer) {
			var olIconsSlider = tns({
				container: olIconsSliderContainer,
				items: 4,
				responsive: {
					1000: {
						items: 6
					}
				},
				nav: false,
				slideBy: 'page',
				controls: true,
				controlsPosition: 'top',
				controlsText:  ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
				edgePadding:0,
				gutter: 0,
				center:false,
				mouseDrag:true,
				loop:false,
				onInit: function () {
					olIconsSliderContainer.querySelectorAll('.tns-controls button').forEach(button => {
						button.type = 'button';
					});
				}
			});
		});
	}
	
	var smallIconsSliderContainers = document.querySelectorAll('.customizer-smallicons-slider');
	if (smallIconsSliderContainers.length > 0) {
		smallIconsSliderContainers.forEach(function(smallIconsSliderContainer) {
			var smallIconsSlider = tns({
				container: smallIconsSliderContainer,
				items: 3,
				responsive: {
					700: {
						items: 5
					}
				},
				nav: false,
				slideBy: 'page',
				controls: true,
				controlsPosition: 'top',
				controlsText:  ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
				edgePadding:0,
				gutter: 10,
				center:false,
				mouseDrag:true,
				loop:false,
				onInit: function () {
					smallIconsSliderContainer.querySelectorAll('.tns-controls button').forEach(button => {
						button.type = 'button';
					});
				}
			});
		});
	}
	
	var fontSliderContainers = document.querySelectorAll('.customizer-font-slider');
	if (fontSliderContainers.length > 0) {
		fontSliderContainers.forEach(function(fontSliderContainer) {
			var fontSlider = tns({
				container: fontSliderContainer,
				items: 3,
				nav: false,
				slideBy: 'page',
				controls: true,
				controlsPosition: 'top',
				controlsText:  ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
				edgePadding:0,
				gutter: 10,
				center:false,
				mouseDrag:true,
				loop:false,
				onInit: function () {
					fontSliderContainer.querySelectorAll('.tns-controls button').forEach(button => {
						button.type = 'button';
					});
				}
			});
		});
	}

	var colorSliderContainers = document.querySelectorAll('.customizer-color-slider');
	if (colorSliderContainers.length > 0) {
		colorSliderContainers.forEach(function(colorSliderContainer) {
		var colorSlider = tns({
			container: colorSliderContainer,
			items: 4,
			responsive: {
				700: {
					items: 6
				}
			},
			nav: false,
			slideBy: 'page',
			controls: true,
			controlsPosition: 'top',
			controlsText: ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
			edgePadding: 0,
			gutter: 10,
			center: false,
			mouseDrag: true,
			loop: false,
			onInit: function() {
				colorSliderContainer.querySelectorAll('.tns-controls button').forEach(function(button) {
					button.type = 'button';
				});
			}
		});
	});
	}
});

// Additional safeguard to ensure all slider buttons have type="button"
// This runs after all sliders are initialized
setTimeout(function() {
	document.querySelectorAll('.tns-controls button').forEach(function(button) {
		if (!button.type || button.type === 'submit') {
			button.type = 'button';
		}
	});
}, 100);

// Simple solution: Prevent slider buttons from submitting forms
document.addEventListener('click', function(e) {
	// Check if the clicked element is a slider control button
	if (e.target.closest('.tns-controls button')) {
		// Don't prevent default - let tiny-slider handle the click
		// Just ensure it doesn't submit any forms
		const button = e.target.closest('.tns-controls button');
		if (!button.type || button.type === 'submit') {
			button.type = 'button';
		}
	}
});

// Also check periodically for any new slider buttons and fix their type
setInterval(function() {
	document.querySelectorAll('.tns-controls button').forEach(function(button) {
		if (!button.type || button.type === 'submit') {
			button.type = 'button';
		}
	});
}, 1000);



window.updateCanvas = function (ctx, data) {
	ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
	if (data.label.type == 'orbit') {
		if (data.selection.set.graphics.length > 1) {
			ctx.drawImage(data.label.backgroundImage2, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
		} else {
			ctx.drawImage(data.label.backgroundImage, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
		}
	} else {
		ctx.drawImage(data.label.backgroundImage, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
	}

	let $data = data;
	let colors = [];
	if (data.selection.color) {
		colors = data.selection.color.values;
	}
	let color_alts = [];
	if (data.selection.color_alt) {
		color_alts = data.selection.color_alt.values;
	}
	//let areas = labelAreas[data.label.size];
	//let areas = labelAreas[data.label.size].map(area => cloneArea(area));
	let areas = labelAreas[data.label.size].map(area => {
		// Create a shallow copy of the area
		const newArea = Object.create(Object.getPrototypeOf(area));
		// Copy all properties
		return Object.assign(newArea, area);
	});


	let labelTypeIndex = 0;
	let currentLabelType = null;
	let i = 0;

	areas.forEach((area, j) => {
		if (data.label.type == 'orbit' && data.selection.set.graphics.length < j+1) {
			return;
		}
		if (area.size != currentLabelType) {
			labelTypeIndex = 0;
			currentLabelType = area.size;
		}
		if (data.label.type != 'combo') {
			area.type = data.label.type;
		}
		i = labelTypeIndex
		area.index = i;
		if (area.type == 'icon') {
			area.backgroundColor = '#ffffff';
		}
		if (['icon', 'monogram', 'orbit'].indexOf(area.type) >= 0) {
			area.hasIcon = !(area.type == 'orbit' && data.texts.Letter == 'x');
		}
		if (area.type == 'photo' && area.size != 'photo') {
			area.hasIcon = true;
		}
		if (data.selection.set) {
			let set = data.selection.set;
			let image = null;
			if (set.graphics.length > 0 && !area.isTextColorLocked) {
				area.textColor = set.graphics[i % set.graphics.length].fontColor;
			}
			if (area.type == 'bagtag' || (area.type=='photo' && area.size != 'circleBagTag')) {
				image = set.bagTags[area.size].image;
				
					area.textColor = set.bagTags[area.size].color;
					area.textColorBack = set.bagTags[area.size].color_back;
				
				// Force the color to stay by preventing color_alt from affecting it
				area.originalTextColor = area.textColor;
				area.isTextColorLocked = true;
				
				if (set.bagTags[area.size].has_back) {
					data.label.has_back = true;
				} else {
					data.label.has_back = false;
				}
			} else {
				image = window.getGraphicImage(set.graphics[i % set.graphics.length].images, area);
			}
			if (['icon', 'graphics', 'photo', 'bagtag', 'shoepals', 'shoepals_icon', 'orbit'].indexOf(area.type) >= 0) {
				if (image) {
					let imgName = set.name + area.size + (i % set.graphics.length);
					if (typeof loadedImages[imgName] == 'undefined') {
						loadedImages[imgName] = {}
					}
					if (typeof loadedImages[imgName].img == 'undefined') {
						loadedImages[imgName].img = new Image();
						loadedImages[imgName].img.src = image.src;
						loadedImages[imgName].img.setAttribute("crossorigin", "anonymous");
						loadedImages[imgName].img.onload = function () {
							window.updateCanvas(ctx, data);
							//window.globalUpdateCanvas();
						}
					}
					if (['icon'].indexOf(area.type) >= 0) {
						area.iconImage = loadedImages[imgName].img;
					} else {
						if (area.type == 'shoepals_icon') {
							area.shoepals_icon = loadedImages[imgName].img;
						} else {
							area.backgroundImage = loadedImages[imgName].img;
						}
					}
				}
			}

			if (set.fontFamily) {
				area.fontFamily = set.fontFamily;
				area.baseline = set.baseline;
			} else {
				if (data.selection.font) {
					area.fontFamily = data.selection.font.family;
				}
			}
			if (set.presets.colors) {
				area.backgroundColor = set.presets.colors[(i) % set.presets.colors.length];
			}
		}
		if (colors.length > 0) {
			let color = colors[(i) % colors.length];
			if (data.label.type == 'white') {
				area.backgroundColor = '#ffffff';
				area.textColor = color;
			} else {
				if (data.selection.color.textColor && area.type != 'bagtag') {
					area.textColor = data.selection.color.textColor;
				}
				area.backgroundColor = color;
			}
		}
		if (color_alts.length > 0 && !area.isTextColorLocked) {
			let color = color_alts[(i) % color_alts.length];
			area.backgroundColorAlt = color;
			if (data.selection.color_alt.textColor) {
				area.textColor = data.selection.color_alt.textColor;
			}
		}
		if (area.backgroundImage) {
			ctx.save();
			ctx.shadowColor = "rgba(0, 0, 0, .4)";
			ctx.shadowBlur = 20;
			ctx.shadowOffsetX = 4;
			ctx.shadowOffsetY = 4;
			ctx.drawImage(area.backgroundImage, area.x, area.y, area.width, area.height);
			ctx.restore();
		} else {
			if (area.shoepals_icon) {
				area.drawShoePalIcon(ctx);
			} else {
				area.drawBGColor(ctx);
			}
		}

		if (!area.textColor) {
			area.textColor = '#000000';
		}

		if (data.selection.font) {
			if (area.type != 'bagtag') {
				area.fontFamily = data.selection.font.family;
				area.baseline = data.selection.font.baseline;
				area.monogram_baseline = data.selection.font.monogram_baseline;
				if (data.label.type == 'monogram') {
					area.fontFamilyMono = data.selection.font.monogram_family;
				}
			}
		}

		switch (area.type) {
			case 'shoepals':
			case 'shoepals_icon':
				area.mirrored = false;
				ctx.save();
				ctx.translate(1000, 1000);
				ctx.rotate(90 * Math.PI / 180);
				ctx.translate(-1000, -1000);
				area.drawText(ctx, $data.texts, $data.label);
				ctx.restore();
				area.mirrored = true;
				ctx.save();
				ctx.translate(1000, 1000);
				ctx.rotate(-90 * Math.PI / 180);
				ctx.translate(-1000, -1000);
				area.drawText(ctx, $data.texts, $data.label);
				ctx.restore();
				break;
			case 'orbit':
				area.drawTextOrbit(ctx, $data.texts, $data.label);
				area.drawLetter(ctx, data.texts.Letter, data.label);
				break;
			case 'photo':
				switch (area.size) {
					case 'photo':
						area.drawPhoto(ctx, $data.photo);
						break;
					case 'circleBagTags':
						area.drawPhoto3(ctx, $data.photo);
						break;
					default:
						area.drawPhoto2(ctx, $data.photo);
				}
				area.drawText(ctx, $data.texts, $data.label);
				break;
			default:
				if (['orbit', 'monogram'].indexOf(data.label.type) >= 0) {
					area.drawLetter(ctx, data.texts.Letter, data.label);
				}
				area.drawText(ctx, $data.texts, $data.label);
		}

		if (area.iconImage) {
			let x = area.iconX;
			let y = area.iconY;
			try {
				ctx.drawImage(area.iconImage, x, y, area.iconWidth, area.iconHeight);
			} catch (ex) {
				ray(ex);
				//ray(area.iconImage);
			}
		}

		try {
			ctx.drawImage(data.label.overlayImage, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
		} catch (ex) {
			//console.warn(data.label);
		}

		labelTypeIndex++;
	});
}

window.globalAddToCart = function (canvas, ctx, data, variantID) {
    if (data.texts.Line_1 === '' || data.texts.Line_1.trim() === '') {
        alert('Please enter text');
        return;
    }
    if (data.bundles.length > 0) {
        if (data.selection.bundle.text == '') {
            //alert('Please enter text for '+data.bundles[0].title.toLowerCase());
            //return;
        }
    }
    if (customizerApp.getLoading()) {
        return;
    }
    customizerApp.setLoading(true);

    let cartItems = [];
    let bundleHash = Date.now().toString().hashCode();

    let qty = 1;
    if (data.label.type == 'orbit') {
        qty = customizerApp.getQuantity();
    }

    // Add all selected bundle variants to cart
    if (data.bundles.length > 0) {
        console.log('Bundle data:', data.bundles);
        console.log('Selected bundle variants:', data.selection.bundle.variants);
        
        data.bundles.forEach(bundle => {
            const selectedVariantId = data.selection.bundle.variants[bundle.id];
            console.log(`Processing bundle ${bundle.id}, selected variant: ${selectedVariantId}`);
            
            if (selectedVariantId) {
                cartItems.push({
                    id: selectedVariantId,
                    quantity: qty,
                    properties: {
                        _bundle: bundleHash
                    },
                });
                console.log(`Added bundle variant ${selectedVariantId} to cart`);
            }
        });
    }
    // For backwards compatibility
    else if (data.selection.bundle.variant) {
        cartItems.push({
            id: data.selection.bundle.variant,
            quantity: qty,
            properties: {
                //Name: data.selection.bundle.text,
                _bundle: bundleHash
            },
        });
    }

    // Initialize formData with required properties first
    let formData = {
        id: variantID,
        quantity: qty,
        properties: [
            { key: '_Product ID', value: data.productID },
            { key: '_Product Code', value: data.productCode },
            { key: '_Confirmed', value: 'yes' },
        ]
    };

    if (data.bundles.length > 0 || data.selection.bundle.variant) {
        formData.properties.push({ key: '_bundle', value: bundleHash });
    }


    if (data.selection.font) {
        if (data.label.type == 'monogram') {
            formData.properties.push({ key: 'Icon', value: data.selection.font.name });
            formData.properties.push({ key: 'Icon', value: data.selection.font.name });
        } else {
            formData.properties.push({ key: 'Font', value: data.selection.font.name });
        }
    }

    if (data.selection.set) {
        let propName = '';
        switch (data.label.type) {
            case 'icon':
                if (data.product.title.includes("Allergy")) {
                    propName = 'Allergy Type';
                } else {
                    propName = 'Icon Set';
                }
                if (data.selection.set.presets.colors) {
                    formData.properties.push({ key: 'Color', value: data.selection.set.presets.name });
                }
                break;
            case 'orbit': propName = 'Color'; break;
            case 'shoepals_icon': propName = 'Icon Set'; break;
            case 'combo': propName = 'Icon Set'; break;
            default: propName = 'Color'; break;
        }
        formData.properties.push({ key: propName, value: data.selection.set.name });
        if (data.label.type == 'combo') {
            formData.properties.push({ key: 'Bag_Tag', value: data.selection.set.name });
        }
        if (data.selection.set.fontName && !data.selection.font && data.label.type != 'bagtag') {
            formData.properties.push({ key: 'Font', value: data.selection.set.fontName });
        }
    }

    if (data.selection.color_alt) {
        formData.properties.push({ key: 'Color-1', value: data.selection.color.name });
        formData.properties.push({ key: 'Color-2', value: data.selection.color_alt.name });
    } else {
        if (data.selection.color) {
            formData.properties.push({ key: 'Color', value: data.selection.color.name });
        }
    }

    if (data.texts.Letter) {
        if (data.label.type == 'orbit') {
            formData.properties.push({ key: 'Icon', value: data.orbitIcons[data.texts.Letter] });
        } else {
            if (data.label.type == 'monogram') {
                formData.properties.push({ key: 'Line-mono', value: data.texts.Letter });
            }
        }
    }

    if (data.label.type == 'photo') {
        formData.properties.push({ key: '_Uploaded Image', value: data.photo.shopify });
    }

    for (let i=1; i<=data.label.textLines; i++) {
        formData.properties.push({ key: 'Line-'+i, value: data.texts['Line_'+i] });
    }

    if (data.texts['Line_Back'] && data.selection.set.bagTags[data.label.size].has_back) {
        formData.properties.push({ key: 'Line-Back-1', value: data.texts['Line_Back'] });
    }

    // Convert the properties array to an object
    let propertiesObject = {};
    formData.properties.forEach(prop => {
        propertiesObject[prop.key] = prop.value;
    });
    formData.properties = propertiesObject;

    let preview = document.createElement('canvas');
    let previewCtx = preview.getContext('2d');
    preview.width = 1000;
    preview.height = 1000;
    previewCtx.drawImage(canvas, 0, 0, 1000, 1000);

    // fetch start for checkout image
    fetch(doFunctionURL, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic N2NiOTllODctYTYyMC00MTM5LTlhOTgtZWVjMzBjZTdiM2Q4OmpYaDZ2VjdMRXZXak5OcTkyMVpEelZBbWZ5VlFrdzBiVDdiWlVlYWRNR0JaMzN4UTFHcXVqYms3QkxpY3pUS1o=',
        },
        body: JSON.stringify({ image: preview.toDataURL('image/jpeg', .6) }),
    }).then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    }).then(response => {
        // Add image URL if upload succeeded
        formData.properties['_newImageUrl'] = 'https://cdn.shopify.com/s/files/1/1041/4754/files/'+response.filename+'.jpg';
    }).catch(error => {
        console.warn('Image upload failed:', error);
        // Continue without the image URL
    }).finally(() => {
        // Always add formData to cartItems, even if image upload failed
        cartItems.push(formData);

        // Proceed with cart addition
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: cartItems,
            }),
        }).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            window.refreshCartContents(data);
            bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();
        }).catch(error => {
            console.error('Error adding item to cart:', error);
            alert('There was an error adding the item to your cart. Please try again.');
        }).finally(() => {
            customizerApp.setLoading(false);
        });
    });
};

window.getGraphicImage = function (images, area) {
	let size = area.size;
	if (size == 'shoepals_icon') {
		size = 'shoepals';
	}
	if (area.type == 'orbit') {
		return images['large'];
	}
	if (images[size]) {
		if (images[size].src != '') {
			return images[size];
		} else {
			if (images['large'].src != '') {
				return images['large']
			} else {
				return false;
			}
		}
	}
	return  false;
}

const updateUpsellCanvases = function () {
	document.querySelectorAll('.upsell-canvas').forEach(function (el) {
		const canvas = el.querySelector('canvas');
		canvas.width = CANVAS_WIDTH;
		canvas.height = CANVAS_HEIGHT;
		const ctx = canvas.getContext('2d');
		const data = getUpsellElementData(el);

		updateCanvas(ctx, data);
	});
}

setTimeout(function () {
	updateUpsellCanvases();
}, 500)

const getUpsellElementData = function (el) {
    let variant = el.dataset.variant;
    const data = {
        texts: {
            Line_1: el.dataset.line1 || 'Suzie Q.',  // Use the data-line1 attribute from the element
            Line_2: '',
            Line_3: '',
            Line_4: '',
            Line_Back: '',
            Letter: 'S',
        },
        selection: {
            bundle: {
                variant: null,
                variants: {}, // Add support for multiple bundle variants
                text: '',
            },
            color: null,
        },
        label: {
            backgroundImage: el.querySelector('img'),
            type: el.dataset.type,
            size: el.dataset.size,
            textLines: el.dataset.size === 'mini' ? 1 : 2, // Set textLines to 1 for mini labels
        },
        bundles: [],
        photo: {},
        orbitIcons: {
            'x': 'No Icon',
            'k': 'Gingerbread',
            'l': 'Santa Hat',
            'm': 'Snowflake',
            'n': 'Christmas Tree',
			'a': 'Star',
            'b': 'Heart',
            'c': 'Unicorn',
            'd': 'Rocket',
            'e': 'Dinosaur',
            'f': 'Flower',
            'g': 'Teddy Bear',
            'h': 'Airplane',
            'i': 'Bow',
            'j': 'Allergy'
        },
        product: allCustomizerData[el.dataset.handle].data,
        productCode: allCustomizerData[el.dataset.handle].pCodes[el.dataset.variant],
        productID: allCustomizerData[el.dataset.handle].pCodes[el.dataset.variant],
    };

    // Clear other lines if size is mini
    if (data.label.size === 'mini') {
        data.texts.Line_2 = '';
        data.texts.Line_3 = '';
        data.texts.Line_4 = '';
        data.texts.Line_Back = '';
    }

    if (data.label.type == 'orbit') {
        let icon = Cookie.get('Orbit Icon');
        if (!icon) {
            icon = 'x';
        }
        data.texts.Letter = icon;
    }
    if (data.label.type == 'monogram') {
        let letter = Cookie.get('Letter');
        if (letter !== null) {s
            data.texts.Letter = letter;
        }
    }
    ['color', 'font', 'set', 'letter'].forEach(function (option) {
        if (typeof el.dataset[option] != "undefined") {
            let value = el.dataset[option];
            if (value) {
                if (typeof allCustomizerData[el.dataset.handle].options[option+"s"] != "undefined") {
                    data.selection[option] = allCustomizerData[el.dataset.handle].options[option+"s"].filter(function (val) {
                        return val.name == value;
                    })[0];
                }
            }
        }
    });
    for (let i = 0; i <= 4; i++) {
        let val = Cookie.get('Line_'+i);
        if (val) {
            data.texts['Line_'+i] = val;
        }
    }
    // set product code & ID
    if (data.label.type === 'orbit') {
        data.productCode += this.texts.Line_2 ? '2' : '1';
        data.productID = data.productID.toLowerCase();
        data.productID += this.texts.Line_2 ? '2' : '1';
    }
    return data;
}
document.addEventListener('click', function(e) {
	const target = e.target.closest('.upsell-canvas a.atc, .upsell-canvas a.pdp');
	if (target) {
		e.preventDefault();
		const parent = target.closest('.upsell-canvas');
		const canvas = parent.querySelector('canvas');
		const data = getUpsellElementData(parent);

		if (target.classList.contains('atc')) {
			globalAddToCart(
				canvas,
				canvas.getContext('2d'),
				data,
				parent.dataset.variant
			);
		} else if (target.classList.contains('pdp')) {
			let params = {};
			for (let key in data.texts) {
				if (data.texts[key]) {
					params[key] = data.texts[key];
				}
			}
			for (let key in data.selection) {
				if (key == 'bundle') {
					continue;
				}
				if (data.selection[key]) {
					params[key] = data.selection[key].name;
				}
			}
			window.location.href = target.href + '?' + new URLSearchParams(params).toString();
		}
	}
});

addEventListener('updated.sd.cart', function () {
	setTimeout(function () {
		updateUpsellCanvases();
	}, 500)
})

function cloneArea(area) {
	// Store original properties before creating new instance
	const originalProps = {
		iconWidth: area.iconWidth,
		iconHeight: area.iconHeight,
		iconX: area.iconX,
		iconY: area.iconY,
		iconPosition: area.iconPosition,
		hasIcon: area.hasIcon,
		size: area.size,
		type: area.type,
		zoom: area.zoom,
		backgroundColor: area.backgroundColor,
		textColor: area.textColor,
		fontFamily: area.fontFamily,
		baseline: area.baseline,
		textX: area.textX,
		textY: area.textY,
		textMX: area.textMX,
		textMY: area.textMY,
		maxTextWidth: area.maxTextWidth,
		maxTextHeight: area.maxTextHeight,
		maxTextHeightBack: area.maxTextHeightBack,
		textBackY: area.textBackY,
		duoAngle: area.duoAngle,
		duoStart: area.duoStart,
		duoSplit: area.duoSplit,
		duoSplitWidth: area.duoSplitWidth,
		duoSplitColor: area.duoSplitColor
	};

	let newArea;

	if (area instanceof TagPalsArea) {
		newArea = new TagPalsArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof CircleLabelArea) {
		newArea = new CircleLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof HexagonLabelArea) {
		newArea = new HexagonLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof RectangleLabelArea) {
		newArea = new RectangleLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof HolidayGiftTagsLabelArea) {
		newArea = new HolidayGiftTagsLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof AllergyLabelArea) {
		newArea = new AllergyLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof ShoeLabelArea) {
		newArea = new ShoeLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof ShoeLabelArea2) {
		newArea = new ShoeLabelArea2(
			area.x,
			area.y,
			area.width/originalProps.zoom,
			area.height/originalProps.zoom,
			area.gap,
			originalProps.zoom,
			originalProps.type
		);
	} else if (area instanceof MediumRectangleLabelArea) {
		newArea = new MediumRectangleLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof MiniRectangleLabelArea) {
		newArea = new MiniRectangleLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof OrbitLabelArea) {
		newArea = new OrbitLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof RectangleBagTagArea) {
		newArea = new RectangleBagTagArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof CircleBagTagArea) {
		newArea = new CircleBagTagArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof PhotoLabelArea) {
		newArea = new PhotoLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	}

	if (newArea) {
		// Restore original properties
		Object.keys(originalProps).forEach(key => {
			if (originalProps[key] !== undefined) {
				newArea[key] = originalProps[key];
			}
		});

		return newArea;
	}

	console.warn('Unknown area type:', area);
	return area;
}
